import { type AuthorizedUser, type ChangePassword, type ResetPassword, type UserClient, type UserModel } from '@models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const AuthActions = createActionGroup({
  events: {
    'Auth Action Error': props<{ error: Error; }>(),
    'Auth Change User Password': props<{ data: ChangePassword; }>(),
    'Auth User Password Changed': emptyProps(),
    'Forgot Password': props<{ email: string; }>(),
    'Forgot Password Success': emptyProps(),
    'Login': props<{
      user: AuthorizedUser & {
        isLoading?: boolean;
      };
    }>(),
    'Logout': emptyProps(),
    'Password Recovered': emptyProps(),
    'Password Recovery': props<{ recoveryData: ResetPassword; }>(),
    'Refresh Profile': emptyProps(),
    'Refresh Profile Success': props<{ user: UserModel; }>(),
    'Super Admin Client Created': props<{ newClient: UserClient; }>(),
    'Update Notification Data': props<{ data: Partial<UserModel>; userId: string; }>(),
    'Update Personal Data': props<{ data: Partial<UserModel>; }>(),
    'Update Personal Data Success': props<{ user: UserModel; }>(),
  },
  source: 'Auth',
});
